var api = require("!../../../../../../../../../../../usr/lib/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../../../../../../usr/lib/node_modules/css-loader/dist/cjs.js!../../../../../../../../../../../usr/lib/node_modules/sass-loader/dist/cjs.js!./clipboard-copy.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {"injectType":"singletonStyleTag","attributes":{"id":"foreman_core_css"}};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};